// istanbul ignore file
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import AllTimeSlots from 'reservations/availabilities/components/AllTimeSlots';
import { ANYTIME } from 'reservations/availabilities/constants';
import type { Slot } from 'reservations/availabilities/types';

export type ViewAllAvailableTimeSlotsProps = {
  time: number;
  slots: (Slot | null)[];
  name: string;
  // eslint-disable-next-line unused-imports/no-unused-vars
  handleSlotClick: (timeSlot: string) => void;
};

function ViewAllAvailableTimeSlots({
  time,
  slots,
  handleSlotClick,
  name
}: ViewAllAvailableTimeSlotsProps) {
  const [
    shouldRenderAllAvailableTimeSlots,
    setShouldRenderAllAvailableTimeSlots
  ] = useState(false);

  if (time === ANYTIME) {
    return null;
  }

  if (!shouldRenderAllAvailableTimeSlots) {
    return (
      <Grid
        container
        direction="column"
        spacing="16px"
        alignContent="center"
        sx={{ mt: '32px' }}
      >
        <Grid item>
          <Button
            onClick={() => setShouldRenderAllAvailableTimeSlots(true)}
            sx={{ textTransform: 'none' }}
          >
            View all available times
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction="column" spacing="16px" sx={{ mt: '32px' }}>
      <Grid item>
        <Divider>
          <Typography
            sx={theme => ({ fontSize: '14px', color: theme.palette.soy.main })}
          >
            All available times
          </Typography>
        </Divider>
      </Grid>
      <Grid container item direction="row" spacing="4px">
        <AllTimeSlots
          slots={slots}
          handleSlotClick={handleSlotClick}
          name={name}
        />
      </Grid>
    </Grid>
  );
}

export default ViewAllAvailableTimeSlots;
